var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [
          _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-top-center" },
            [
              _c("md-progress-spinner", {
                attrs: {
                  "md-diameter": 50,
                  "md-stroke": 5,
                  "md-mode": "indeterminate"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "md-layout md-gutter md-alignment-top-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-20 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
              },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-fab",
                    on: {
                      click: function($event) {
                        return _vm.goBack()
                      }
                    }
                  },
                  [_c("md-icon", [_vm._v("arrow_back")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-60 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
              },
              [
                _c(
                  "md-card",
                  [
                    _c("md-card-header", [
                      _c("div", { staticClass: "md-title" }, [
                        _vm._v("Veranstaltungsempfehlungen")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "md-card-content",
                      [
                        _vm.events.length > 0
                          ? _c("p", [
                              _vm._v(
                                "\n            Die unten stehenden Veranstaltungen werden Ihnen aufgrund Ihrer\n            Angaben in Ihrem Unternehmensprofil angezeigt.\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.events.length == 0
                          ? _c(
                              "div",
                              [
                                _vm._v(
                                  "\n            Um Ihnen Veranstaltungsempfehlungen anzeigen zu können, benötigen\n            wir Angaben in Ihrem Unternehmensprofil. Sie können dieses\n            "
                                ),
                                _c(
                                  "router-link",
                                  { attrs: { to: { name: "ProfileCreate" } } },
                                  [_vm._v("hier")]
                                ),
                                _vm._v(
                                  " bearbeiten. Außerdem brauchen wir mindestens ein Kriterium\n            anhand dessen wir Ihnen Empfehlungen geben können.\n          "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "md-checkbox",
                              {
                                model: {
                                  value: _vm.sector,
                                  callback: function($$v) {
                                    _vm.sector = $$v
                                  },
                                  expression: "sector"
                                }
                              },
                              [_vm._v("Branche im Unternehmensprofil")]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-checkbox",
                              {
                                model: {
                                  value: _vm.location,
                                  callback: function($$v) {
                                    _vm.location = $$v
                                  },
                                  expression: "location"
                                }
                              },
                              [_vm._v("Adresse im Unternehmensprofil")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "EventSearch" } } },
                              [_vm._v("Hier")]
                            ),
                            _vm._v(
                              " können Sie auch nach passenden Veranstaltungen suchen.\n          "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.events, function(item) {
                          return _c(
                            "div",
                            { key: item.hash },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "no-link",
                                  attrs: {
                                    to: {
                                      name: "EventDetail",
                                      params: { hash: item.hash }
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "md-card",
                                    {
                                      staticClass:
                                        "margin-twenty md-alignment-top-center md-elevation-1",
                                      attrs: { "md-with-hover": "" }
                                    },
                                    [
                                      _c(
                                        "md-card-header",
                                        { staticClass: "md-title" },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                      _vm._v(" "),
                                      _c("md-card-content", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.shorten(item.description)
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "md-layout-item md-size-20 md-medium-size-15 md-small-size-10 md-xsmall-size-0"
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1143b597", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1143b597","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/profile/events/Events.vue
// module id = null
// module chunks = 